module.exports = __webpack_public_path__ + "img/zzfwxt_charact_5.a1219b5e.svg";